import { ApplicationConfig, ApplicationSection, FieldType } from '@bybeam/platform-types';

const SECTIONS: ApplicationSection[] = [
  {
    key: 'learnMore',
    name: 'Leaning into Digital Opportunities',
    overview: {
      description: 'Learn more about this program',
      title: 'Leaning into Digital Opportunities',
    },
    questionGroups: [
      {
        key: 'learnMore',
        name: 'Leaning into Digital Opportunities',
        questions: [
          {
            key: 'link',
            copy: { title: 'Leaning into Digital Opportunities' },
            layout: 'panel',
            fields: [
              {
                key: 'link',
                type: FieldType.Typography,
                copy: `
Leaning into Digital Opportunities (LIDO)’s mission is to promote digital for entrepreneurs. If you are starting a business, nurturing a side hustle, or thinking about starting something, LIDO wants to work with you!

Qualified applicants are eligible to receive free laptops and wi-fi. To learn more, visit [http://lidokc.org/](http://lidokc.org/).
                `,
                props: { variant: 'largeBody', alignment: 'left' },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'attestation',
    name: 'Attestation',
    overview: {
      title: 'Attestation',
      description: '',
    },
    questionGroups: [
      {
        key: 'attestation',
        name: 'Attestation',
        questions: [
          {
            key: 'attestation',
            copy: { title: 'Attestation' },
            layout: 'panel',
            fields: [
              {
                key: 'attestation.info',
                type: FieldType.Typography,
                copy: 'I understand that to apply for this program, I must visit the external site: [http://lidokc.org/](http://lidokc.org/)',
                props: { variant: 'largeBody', alignment: 'center' },
              },
              {
                key: 'attestation.confirm',
                type: FieldType.Checkbox,
                copy: 'I confirm.',
              },
            ],
          },
        ],
      },
    ],
  },
];

const CONFIG: ApplicationConfig = {
  introPages: [],
  overrides: {
    statuses: [
      {
        status: 'Application',
        label: '',
        message:
          'This is an external program with its own application. To learn more & apply, visit [http://lidokc.org/](http://lidokc.org/).',
        referralMessage: 'You have been referred to this program.',
        action: 'Click here to learn more',
      },
      {
        status: 'InProgress',
        label: '',
        message:
          'This is an external program with its own application. To learn more & apply, visit [http://lidokc.org/](http://lidokc.org/).',
        referralMessage: 'You have been referred to this program.',
        action: 'Click here to learn more',
      },
    ],
    submission: {
      title: 'What happens next?',
      bullets: [
        {
          key: 'review',
          title: 'Application review',
          icon: 'description',
          description:
            'While we look at your application, we might send you an email to ask for more information or notify you of next steps',
        },
      ],
    },
  },
  sections: SECTIONS,
};

export default CONFIG;
